import CustomDrawer from "../shared/CustomDrawer";
import { useRequest } from "../../api/utils/useRequest";
import { BalootUserAPIs } from "../../api/APIs";
import { Box, Button, Typography } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { toToman } from "../../utils/Utils";
import { SuccessPaymentDrawer } from "./SuccessPaymentDrawer";
import { useState } from "react";

export function PaymentDrawer(props) {
  const {
    open,
    setOpen,
    totalAmount,
    wage,
    walletAmount,
    toPayAmount,
    units,
    financialAsset,
  } = props;
  const { loading, apiCall: invest } = useRequest(BalootUserAPIs.invest);
  const [successOpen, setSuccessOpen] = useState(false);

  const onSubmit = () => {
    invest({
      data: { assetId: financialAsset.id, amount: totalAmount },
      onSuccess: (response) => {
        if (response.url) {
          window.open(response.url, "_self");
        } else {
          setSuccessOpen(true);
        }
      },
    });
  };

  return (
    <CustomDrawer
      open={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <img src={financialAsset.iconPath} width={40} height={40} />
        <Typography mt={2} component={"div"} variant="body2" color="grey.2">
          خرید{" "}
          <Box display={"inline"} typography="h5">
            {units}
          </Box>{" "}
          واحد صندوق{" "}
          <Box display={"inline"} typography="h5">
            {financialAsset.name}
          </Box>
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", mt: 2 }}>
        {[
          { title: "قیمت خرید (تومان)", value: toToman(totalAmount) },
          { title: "کارمزد سامانه (تومان)", value: toToman(wage) },
          { title: "موجودی قلک (تومان)", value: toToman(walletAmount) },
        ].map((item) => {
          return (
            <Box
              key={item.title}
              sx={{
                mt: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="subtitle1" color="grey.4">
                {item.title}
              </Typography>
              <Typography variant="h5" color="grey.2">
                {item.value}
              </Typography>
            </Box>
          );
        })}
      </Box>
      <Box
        sx={{
          mt: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="subtitle1" color="grey.2">
          قابل پرداخت(تومان)
        </Typography>
        <Typography variant="h2" color="primary.main">
          {toToman(toPayAmount)}
        </Typography>
      </Box>
      <LoadingButton
        onClick={onSubmit}
        loading={loading}
        sx={{ mt: 2, typography: "h3", color: "common.white" }}
        fullWidth
        variant="contained"
      >
        ثبت درخواست خرید
      </LoadingButton>
      <SuccessPaymentDrawer
        assetName={financialAsset.name}
        open={successOpen}
        setOpen={setSuccessOpen}
      />
    </CustomDrawer>
  );
}
